import { isReadOnly } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/app';
import { getPlan } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/plan';
import { getToolBarVisibilityState } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/query/tool-bar';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { createStructuredSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';
import type { StateProps } from './types';

export const getPlanId = (state: State) => getPlan(state).id;
export const getPlanTitle = (state: State) => getPlan(state).title;
export const getOpenDeleteDialog = (state: State) =>
	state.ui.Top.TitleBar.PlanSettings.deleteDialogOpen;
export const getDeleteButtonEnabled = (state: State) =>
	state.ui.Top.TitleBar.PlanSettings.deleteButtonEnabled;

export default createStructuredSelector<State, {}, StateProps>({
	deleteButtonEnabled: getDeleteButtonEnabled,
	deleteDialogOpen: getOpenDeleteDialog,
	isReadOnly,
	planTitle: getPlanTitle,
	planId: getPlanId,
	showToolBar: getToolBarVisibilityState,
});
